import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CreateArtifactContext } from "../../../context/CreateArtifactContext";
import { useNavigationBar } from "../../../context/NavigationContext";
import { ContentState, SKLetterArtifact } from "../../../models/SKArtifact";
import "react-datepicker/dist/react-datepicker.css";
import * as Yup from "yup";
import { AddTextField } from "../../../components/AddTextField";
import { AddTextAreaField } from "../../../components/AddTextAreaField";
import { isEditable } from "@testing-library/user-event/dist/utils";

export default function AddLetter() {
  const { contentData, artifactId, updateContentData, loading, saveData, isEditable } = useContext(CreateArtifactContext);
  const { setNavProps } = useNavigationBar();
  const navigate = useNavigate();
  const [editable, setEditable] = useState<boolean>(true);
  const [isValidForm, setIsValidForm] = useState(false);
  const [letterData, setLetterData] = useState<SKLetterArtifact | undefined>(undefined);

  const schema = Yup.object().shape({
    letterTitle: Yup.string().required(),
    letterMessage: Yup.string().required(),
  });

  useEffect(() => {
    const validate = async () => {
      try {
        await schema.validate(contentData, { abortEarly: false });
        setIsValidForm(true);
      } catch (err) {
        setIsValidForm(false);
      }
    };
    validate();
  }, [contentData, schema]);

  useEffect(() => {
    if (contentData.status === ContentState.DRAFT) {
      setEditable(true);
    } else {
      setEditable(false);
    }
  }, [contentData]);

  useEffect(() => {
    setNavProps(prev => ({
      ...prev,
      backArrow: false,
      buttonTitle: "Done",
      title: "Add Letter",
      enableLink: isEditable ? isValidForm : false,
      getActionItems: undefined,
      onNext: isEditable ? submit : undefined,
      onClose: () => navigate(-1),
      onEdit: undefined,
    }));
  }, [setNavProps, letterData, isEditable]);

  useEffect(() => {
    setLetterData(contentData as SKLetterArtifact);
  }, [contentData]);

  const submit = async () => {
    await saveData();
    window.history.back();
  };

  return (
    <>
      <div className="flex flex-col mt-[12px] gap-[30px]">
        <AddTextField
          name={"lettertitle"}
          title={"Add Letter Title"}
          note={"Choose a title that represents the topic, purpose or theme of the letter."}
          placeholder={"Letter Title"}
          index={1}
          charAllowed={50}
          value={(contentData as SKLetterArtifact).letterTitle}
          onChange={async e => {
            updateContentData({ letterTitle: e.target.value! });
          }}
          disabled={!isEditable}
        />
        <AddTextAreaField
          name={"lettermessage"}
          title={"Add Letter Text"}
          note={"Maximum text length of 5,000 characters."}
          placeholder={"Letter Text"}
          index={2}
          height={100}
          charAllowed={5000}
          value={(contentData as SKLetterArtifact).letterMessage}
          onChange={async e => {
            updateContentData({ letterMessage: e.target.value! });
          }}
          disabled={!isEditable}
        />
      </div>
    </>
  );
}
